"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const adyen_1 = require("../helper/adyen");
class ShopwarePaymentMethods {
    api = new ecommerce_1.PaymentMethodApi(configuration_1.default);
    loading = false;
    paymentMethodList = [];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            paymentMethodList: mobx_1.observable,
            paymentMethods: mobx_1.computed,
            validPaymentMethods: mobx_1.computed,
            isLoading: mobx_1.computed,
            loadPaymentMethods: mobx_1.action.bound,
        });
    }
    get paymentMethods() {
        return this.paymentMethodList.slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
    }
    get validPaymentMethods() {
        return this.paymentMethods.filter((paymentMethod) => {
            if (!(0, adyen_1.isAdyenPaymentMethod)(paymentMethod)) {
                return true;
            }
            return (0, adyen_1.isValidAdyenPaymentMethod)(paymentMethod);
        });
    }
    get isLoading() {
        return this.loading;
    }
    isAdyenPaymentMethod(id) {
        return (this.paymentMethods.length > 0 ? Promise.resolve() : this.loadPaymentMethods())
            .then(() => !!id &&
            this.paymentMethods.filter((method) => method.id === id && (0, adyen_1.isAdyenPaymentMethod)(method)).length > 0)
            .catch(() => false);
    }
    loadPaymentMethods() {
        this.loading = true;
        return this.api
            .readPaymentMethods({
            onlyAvailable: true,
        })
            .then((0, mobx_1.action)((response) => {
            this.paymentMethodList = response?.elements ?? [];
        }))
            .catch((0, mobx_1.action)(() => {
            this.paymentMethodList = [];
            return Promise.reject();
        }))
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
}
exports.default = new ShopwarePaymentMethods();
